/*
 * @Author: error: error: git config user.name & please set dead value or install git && error: git config user.email & please set dead value or install git & please set dead value or install git
 * @Date: 2024-01-15 14:44:26
 * @LastEditors: Auerbach
 * @LastEditTime: 2025-05-28 14:19:11
 * @FilePath: \app\src\main.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { createApp } from "vue"
import App from "./App.vue"
import router from "@/router/router"
import axios from "axios"
import "@/assets/style/main.scss"
// import '@/assets/style/theme.scss'
import MyGlobalCom from '@/components/index'  // 注册全局组件
import 'nprogress/nprogress.css'
import './assets/css/tailwind.css' // 引入 Tailwind 样式
import 'virtual:svg-icons-register'

import { ElSelect, ElTree, ElInput } from 'element-plus'
ElSelect.props.clearable = {
  type: Boolean,
  default: true
}
ElTree.props.indent = {
  type: Number,
  default: 8
}

import '@fortawesome/fontawesome-free/css/all.min.css'
// import DataVVue3 from '@kjgl77/datav-vue3'

import ElementPlus from 'element-plus'
import 'element-plus/theme-chalk/src/index.scss'

// 引入pinia和持久化插件
import { createPinia } from 'pinia'
import piniaPluginPersist from 'pinia-plugin-persistedstate'
const pinia = createPinia()
pinia.use(piniaPluginPersist)

const app = createApp(App)
app.config.globalProperties.$axios = axios
// 饿了么图标
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
for (const [key, component] of Object.entries({
  ...ElementPlusIconsVue,
})) {
  app.component(key, component)
}

// import '@/plugins/modules/element-plugin'

app.use(router)
.use(ElementPlus)
// .use(DataVVue3)
.use(MyGlobalCom).use(pinia).mount("#app")
